<template>
  <Login v-if="!loading"></Login>
  <div v-else class="loading-screen" :class="className">
    <i class="mdi mdi-spin mdi-loading mdi-48px"></i>
  </div>
</template>
<script>
import Login from "../layouts/Login.vue";
export default {
  components: {
    Login,
  },
  computed: {
    loading() {
      return this.$store.state.loading;
    },
  },
};
</script>
<style lang="less">
@import url("/css/colors.less");
@import url("/css/buttons.less");
.login-page {
  padding: 2em;
  box-sizing: border-box;

  form {
    label {
      color: white;
      padding-bottom: 0.1em;
      display: inline-block;
      width: 100%;

      [type="text"],
      [type="password"],
      [type="email"],
      [type="number"] {
        padding: 0.5em;
        border: 1px solid #ccc;
        border-radius: 0;
        width: 100%;
        margin-top: 0.25em;
      }
    }
    .button.primary {
      padding: 0.85rem 1rem;
    }
  }

  .links {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    padding: 1em 0px;

    a {
      color: white;
      text-decoration: none;
      font-size: 0.8em;
    }
  }
}

.easy-money {
  .login-page {
    .links {
      a {
        display: inline-block;
        border: 2px solid var(--accent);
        border-radius: 2em;
        padding: 0.5em 2em;
        transition: opacity 0.25s ease-in-out;

        &:hover {
          opacity: 0.75;
        }
      }
    }
  }
}
</style>
